var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Career = (function (Career) {

        Career.Messages = (function (Messages) {

            Messages.Submit = function (firstname, lastname, email, phone, address, message, jobTitle, jobId, careerFileUpload, reCaptchaCode) {
                var data = {
                    Email: email,
                    FirstName: firstname,
                    LastName: lastname,
                    Phone: phone,
                    Address: address,
                    Message: message,
                    JobTitle: jobTitle,
                    JobId: jobId,
                    CvFileUploaded: careerFileUpload,
                    reCaptchaCode: reCaptchaCode
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Career.Messages.Submit', data);
            };
            Messages.Submit.className = 'Vendd.Career.Messages.Submit';

            Messages.SubmitSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Career.Messages.SubmitSuccess', response);
            };
            Messages.SubmitSuccess.className = 'Vendd.Career.Messages.SubmitSuccess';

            Messages.SubmitFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Career.Messages.SubmitFailure', response);
            };
            Messages.SubmitFailure.className = 'Vendd.Career.Messages.SubmitFailure';

            return Messages;

        })(Career.Messages || {});

        return Career;

    })(Vendd.Career || {});

return Vendd;

})(Vendd || {});